import { useSelector } from 'app/store';
import { activeElementLinkIdSelector } from 'modules/activeElement/externalSelectors';
import { linksLinkApIdSelector, linksLinkClientIdSelector } from 'modules/links/slice';

import WifiBottomPanel from '../components/compositions/WifiBottomPanel';
import ApDevicePanel from './ApDevicePanel';
import ClientDevicePanel from './ClientDevicePanel';
import WifiPanelResultsDisplay from './WifiPanelResultsDisplay';

const WifiBottomPanelContainer = () => {
  const linkId = useSelector(activeElementLinkIdSelector);
  const apId = useSelector((state) => linksLinkApIdSelector(state, linkId));
  const clientId = useSelector((state) => linksLinkClientIdSelector(state, linkId));

  if (!apId || !clientId) {
    return null;
  }

  return (
    <WifiBottomPanel
      apId={apId}
      clientId={clientId}
      linkId={linkId}
      ApDevicePanel={ApDevicePanel}
      ClientDevicePanel={ClientDevicePanel}
      PanelResultsDisplay={WifiPanelResultsDisplay}
    />
  );
};

export default WifiBottomPanelContainer;
